const LOGO_MAP = {
    // Crypto
    crypto:              '/assets/images/payment-logos/crypto.svg',

    // Debit & Credit Cards (Stripe)
    'American Express':  '/assets/images/payment-logos/amex.svg',
    'JCB':               '/assets/images/payment-logos/jcb.svg',
    'MasterCard':        '/assets/images/payment-logos/mastercard.svg',
    'Visa':              '/assets/images/payment-logos/visa.svg',
    'CB':                '/assets/images/payment-logos/cb.svg',
    'Credit Card':       '/assets/images/payment-logos/cb.svg',
    'Discover':          '/assets/images/payment-logos/discover.svg',
    'Diners Club':       '/assets/images/payment-logos/diner-club.svg',

    // Wallets — YabanPay
    'WeChat Pay':        '/assets/images/payment-logos/wechat-pay.svg',
    'Alipay+':           '/assets/images/payment-logos/alipay.svg',
    'UnionPay WAP':      '/assets/images/payment-logos/union-pay.svg',

    // Wallets — Stripe
    'Revolut Pay':       '/assets/images/payment-logos/revolut.svg',
    'Samsung Pay':       '/assets/images/payment-logos/samsung-pay.svg',
    'Google Pay':        '/assets/images/payment-logos/google-pay.svg',
    'Apple Pay':         '/assets/images/payment-logos/apple-pay.svg',
    'PayPal':            '/assets/images/payment-logos/paypal.svg',

    // Buy Now Pay Later — Stripe
    'Klarna':            '/assets/images/payment-logos/klarna.svg',
};

/**
 * Renders the correct payment method logo for a given key.
 * Falls back to the generic card icon when no logo is mapped.
 */
export const SELF_TITLED_LOGOS = new Set(['Alipay+', 'Visa', 'Klarna', 'Revolut Pay', 'Samsung Pay', 'Apple Pay']);

function getLogoSize(methodKey) {
    if (methodKey === 'crypto')                                    return 'h-14 max-w-[60px]';
    if (methodKey === 'UnionPay WAP')                              return 'h-12 max-w-[60px]';
    if (methodKey === 'WeChat Pay')                                return 'h-8 max-w-[80px]';
    if (methodKey === 'Alipay+')                                   return 'h-6 max-w-[80px]';
    if (['American Express', 'CB', 'Credit Card'].includes(methodKey)) return 'h-10 max-w-[60px]';
    if (methodKey === 'Samsung Pay')                               return 'h-8 max-w-[160px]';
    if (methodKey === 'Apple Pay')                                 return 'h-8 max-w-[60px]';
    if (['Google Pay', 'PayPal'].includes(methodKey))              return 'h-8 max-w-[40px]';
    if (methodKey === 'Visa')                                      return 'h-6 max-w-[60px]';
    if (['Klarna', 'Revolut Pay'].includes(methodKey))             return 'h-4 max-w-[60px]';
    return 'h-8 max-w-[60px]';
}

export default function PaymentLogo({ methodKey }) {
    const src = LOGO_MAP[methodKey] || '/assets/images/card.svg';
    return (
        <img
            src={src}
            alt={methodKey}
            className={`${getLogoSize(methodKey)} object-contain flex-shrink-0 block`}
        />
    );
}
